import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

export const AirwallexFeaturesCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('supportedFeatures')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('paymentProcessing')}</h4>
                        <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
                            <li>{t('airwallexGlobalPayments')}</li>
                            <li>{t('multiCurrencySupport')}</li>
                            <li>{t('realtimeTransactionMonitoring')}</li>
                            <li>{t('threeDSecureAuth')}</li>
                            <li>{t('recurringPaymentsStoredCreds')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('paymentMethods')}</h4>
                        <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
                            <li>{t('visaMastercard')}</li>
                            <li>{t('localPaymentMethods')}</li>
                            <li>{t('digitalWalletSupport')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('supportedCountries')}</h4>
                        <div className="rounded-lg bg-muted p-4">
                            <p className="text-sm text-muted-foreground">
                                {t('airwallexSupportedCountries')}
                            </p>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

